module.exports = __webpack_public_path__ + "img/1.4.fe61812b.png";